import createRoutine from '@/utils/createRoutine'

export const transitionRoutine = createRoutine('transitionRoutine')

export const transitionGetters = {
  TRANSITION_CONFIG: 'TRANSITION_CONFIG'
}

export const TRANSITION_CLEANUP = 'TRANSITION_CLEANUP'
